import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalTerminosUsoComponent } from '@app/shared/components/modal-terminos-uso/modal-terminos-uso.component';
import { LoggerService } from '@app/core/services/logger.service';
const logger = new LoggerService('FooterBarComponent');

@Component({
  selector: 'dhl-footer-bar',
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.scss']
})
export class FooterBarComponent implements OnInit {
  isEnableElement: boolean = true;
  facebook: string = './assets/images/footer/youtube_rgb_black.png';
  twiter: string = './assets/images/footer/twitter.png';
  linkeding: string = './assets/images/footer/linkeding.png';
  instagram: string = './assets/images/footer/instagram.png';
  isLoginForStyle: boolean = false;
  date: Date = new Date();

  // @ViewChild('acceptButton', { static: true }) acceptButton: ElementRef;

  constructor(private readonly router: Router, private readonly location: Location, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.validatePage();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.validatePage();
      }
    });

    this.location.subscribe((event) => {
      logger.info(event);
      this.validatePage();
    });
  }
  getPathUrl(): string {
    return window.location.pathname;
  }

  validatePage() {
    const path = this.getPathUrl();
    const urlArray = path.split('/');
    const uri = urlArray.pop();
    logger.info(`footer: ${path}`);
    if (uri === 'login') {
      this.isEnableElement = false;
      this.isLoginForStyle = true;
    } else {
      this.isEnableElement = true;
      this.isLoginForStyle = false;
    }
  }

  public imagenShowfacebook: string = this.facebook;
  public imagenShowtwiter: string = this.twiter;
  public imagenShowlinkeding: string = this.linkeding;
  public imagenShowinstagram: string = this.instagram;

  redirectToTerms() {
    const dialogRef = this.dialog.open(ModalTerminosUsoComponent, {
      data: {
        title:
          'TÉRMINOS Y CONDICIONES APLICABLES PARA LA PRESTACIÓN DEL SERVICIO DE MENSAJERÍA Y PAQUETERÍA EXPRESS DEL PRODUCTO “EXPRESS DOMESTIC PREPAID ” (EN LO SUCESIVO “SERVICIO PREPAGO”)',
        message: '',
        acceptLabel: 'Cerrar',
        showAccept: true
      },
      panelClass: ['dhl-terms-dialog', 'dhl-generic-dialog']
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      return result;
    });
  }
}
